import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
export const useLoadingStore = defineStore('loading', () => {
    const loadingCount = ref(0)
    const isGlobalLoading = computed(() => loadingCount.value > 0)

    // You can track specific API groups too
    const isAPILoading = ref(false)

    function startLoading() {
        loadingCount.value++
    }

    function stopLoading() {
        loadingCount.value = Math.max(0, loadingCount.value - 1)
    }

    function withGlobalLoading<T>(fn: () => Promise<T>) {
        startLoading()
        return fn().finally(stopLoading)
    }

    function withAPILoading<T>(fn: () => Promise<T>) {
        isAPILoading.value = true
        return fn().finally(() => (isAPILoading.value = false))
    }

    return {
        isGlobalLoading,
        isAPILoading,
        startLoading,
        stopLoading,
        withGlobalLoading,
        withAPILoading,
    }
})
